import React, { Component } from "react";
import styled from "styled-components";

export default class Input extends Component {
  render() {
    const { onChange, ...rest } = this.props;
    return (
      <TextArea
        placeholder="Write your reply"
        onChange={this.onChange}
        {...rest}
      />
    );
  }

  onChange = event => {
    const onChange = this.props.onChange;
    if (onChange) onChange(event.target.value);
  };
}

const TextArea = styled.textarea`
  height: 80px;
  width: 100%;
  padding: 8px 50px 8px 8px;
  resize: none;
  border: none;
  border-top: 1px solid ${props => props.theme.panelBorder};
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/Input.js